import { BRACKET_SETTINGS_ACTION } from 'core/constants/Actions';
import { Action } from 'core/models/ActionTypes'
import { BracketRounds } from 'core/models/Bracket';

const intialState: { bracketRounds: BracketRounds | null, isLoading: boolean } = {
  bracketRounds: null,
  isLoading: false
}

interface ActionType extends Action {
  payload: {
    bracketRounds: BracketRounds;
  }
}

export default function bracketSettingReducer(state = intialState, action: ActionType) {

  switch (action.type) {
    case BRACKET_SETTINGS_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case BRACKET_SETTINGS_ACTION.SUCCESS:
      const { bracketRounds } = action.payload;
      return { ...state, bracketRounds, isLoading: false }

    case BRACKET_SETTINGS_ACTION.FAILURE:
      return { ...state, ...intialState }

    default:
      return state
  }
}